import { CSSProperties } from 'react';

export const statusTagColors: Record<string, CSSProperties> = {
  red: {
    backgroundColor: '#ffe3e3',
    color: '#c92a2a',
    borderColor: '#c92a2a',
  },
  blue: {
    backgroundColor: '#d0ebff',
    color: '#1864ab',
    borderColor: '#1864ab',
  },
  teal: {
    backgroundColor: '#C3FAE8',
    color: '#099268',
    borderColor: '#099268',
  },
  green: {
    backgroundColor: '#b2f2bb',
    color: '#2b8a3e',
    borderColor: '#2b8a3e',
  },
  yellow: {
    backgroundColor: '#fff3bf',
    color: '#e67700',
    borderColor: '#e67700',
  },
  orange: {
    backgroundColor: '#ffd49c',
    color: '#ce7400',
    borderColor: '#ce7400',
  },
  pink: {
    backgroundColor: '#ffdeeb',
    color: '#c2255c',
    borderColor: '#c2255c',
  },
  violet: {
    backgroundColor: '#e5dbff',
    color: '#6741d9',
    borderColor: '#6741d9',
  },
  dark: {
    backgroundColor: '#141517',
    color: '#c1c2c5',
    borderColor: '#c1c2c5',
  },
  brown: {
    backgroundColor: '#e1bca8',
    color: '#61351e',
    borderColor: '#61351e',
  },
  indigo: {
    backgroundColor: '#edf2ff',
    color: '#4c6ef5',
    borderColor: '#4c6ef5',
  },
  default: {
    backgroundColor: '#f1f3f5',
    color: '#868e96',
    borderColor: '#868e96',
  },
};
